export enum CollapsiblePanelEvents {
  TOGGLE = 'toggle',
  PANEL_HEADER_CLICK = 'panelHeaderClick',
  SLOT_CLICK = 'slotClick',
}
